import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCommentCheck = () => {
  return (
    <g>
      <path d="m5.7926 4.3838a.7414.7414 0 0 0 -1.0485 1.0485l3.1759 3.1771a.7412.7412 0 0 0 1.0484 0l6.4516-6.4509a.7414.7414 0 1 0 -1.0488-1.0485l-5.9266 5.9268z" />
      <path d="m15.8638 6.2316a5.6034 5.6034 0 0 0 -.0608-.8206.7419.7419 0 0 0 -1.4674.22 3.9891 3.9891 0 0 1 -1.1264 3.4241l-4.4673 3.8832v-1.9144a.7416.7416 0 0 0 -.7419-.7414h-2.33a4.0514 4.0514 0 1 1 0-8.1027h5.24a.7414.7414 0 0 0 0-1.4829h-5.2391a5.5342 5.5342 0 1 0 0 11.0685h1.5881v2.8a.7575.7575 0 0 0 .4335.6748.7872.7872 0 0 0 .7945-.1149l5.7249-4.9757-.006-.007c.0139-.0119.0315-.0164.0447-.03a5.4657 5.4657 0 0 0 1.6132-3.881z" />
    </g>
  );
};

export default withIcon(IconCommentCheck);
